module.exports = __webpack_public_path__ + "img/portfolio-06-480x253.54c2e6fe.jpg";